<template>
  <!--
      作者：gmshop
      时间：2020-06-25
      描述：插件中心-限时拼团
    -->
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
      <el-tab-pane label="团队业绩" name="first"><Performance v-if="activeName == 'first'"></Performance></el-tab-pane>
      <el-tab-pane label="结算单" name="second"><Statement v-if="activeName == 'second'"></Statement></el-tab-pane>
      <el-tab-pane label="总业绩结算" name="team"><Team v-if="activeName == 'team'"></Team></el-tab-pane>
      <el-tab-pane label="基础设置" name="third"><getSetting v-if="activeName == 'third'"></getSetting></el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import Performance from './performance/index';
import Statement from './statement/index';
import Team from './team/index';
import getSetting from './setting/getSetting.vue';
export default {
  components: {
    /*活动列表*/
    Performance,
    /*结算单*/
    Statement,
    /*总业绩结算*/
    Team,
    /*基础设置*/
    getSetting
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      form: {
        status: 0
      },
      activeName: 'first'
    };
  },
  created() {
    let active_name = localStorage.getItem('activeName')
    if(active_name){
      this.activeName = active_name
      localStorage.clear()
    }
  },
  methods: {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/groupaward/index.vue